import type { Distance, SpatialRectangle } from "@pdfking/math"
import { Scale, Subtract, Total } from "@pdfking/math"
import type { ColorID, PageShape } from "@pdfking/renderer-api"
import { HorizontalAlign } from "@pdfking/renderer-api"

import { ADDRESS, CONTACTS, PALETTE } from "#constants"
import type { ContentLabels } from "#internal"

import { DrawBadge } from "../layout/DrawBadge"
import { PlainText } from "../text/PlainText"

// The lines' size and their pitch, in the logo's height
const FONT = 0.16
const PITCH = 1.4

/** A calendar's footer across `box`: the logo, as tall as the box, on its
 * right, the address on its left and the contacts in its middle, every
 * column standing on the logo's foot. */
export const DrawFooter = ({
  box,
  labels,
}: {
  box: SpatialRectangle<Distance>
  labels: ContentLabels
}): PageShape[] => {
  const logo = box.height
  const font = Scale(logo, FONT)
  // `values` up from the box's foot, the last on it
  const column = (values: string[], align: HorizontalAlign, color: ColorID) =>
    values.map((value, i) =>
      PlainText(
        value,
        box.x,
        Subtract(box.width, Total(logo, Scale(logo, 0.3))),
        Total(box.y, Scale(font, PITCH * (values.length - 1 - i))),
        font,
        color,
        align
      )
    )
  return [
    ...DrawBadge({
      box: { height: logo, width: logo, x: Subtract(Total(box.x, box.width), logo), y: box.y },
      lines: [labels.LOGO_TOP(), labels.LOGO_BOTTOM()],
      spot: true,
    }),
    ...column(ADDRESS, HorizontalAlign.LEFT, PALETTE.text),
    ...column(CONTACTS, HorizontalAlign.CENTER, PALETTE.secondary),
  ]
}
